import { render, staticRenderFns } from "./Orange.vue?vue&type=template&id=53cfdba8&scoped=true&"
import script from "./Orange.vue?vue&type=script&lang=js&"
export * from "./Orange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cfdba8",
  null
  
)

export default component.exports